export default "__VITE_ASSET__L1Sa995g__"